import React from "react";
import { Typography, Checkbox } from "antd";
import { useTranslation } from "react-i18next";
import { PATHS } from "@config/constants";

import "./index.scss";

const { Link, Text } = Typography;

const TermAccept = ({ acceptTerms, setAcceptTerms, showError }) => {
  const { t } = useTranslation();
  const [acceptPolicy, setAcceptPolicy] = React.useState(true)

  return (
    <>
      <Checkbox
        className="page-modal-buy-pack-accept-terms"
        checked={acceptTerms}
        onChange={(e) => setAcceptTerms(e.target.checked)}>
        <b style={{ fontWeight: 600 }}>
          {t("modal.term_need_accept")}{" "}
          <Link href={PATHS.TERM_PAGE} target={"_blank"}>
            {t("terms")}
          </Link>
        </b>
      </Checkbox>
      <Checkbox
        className="page-modal-buy-pack-accept-terms"
        checked={acceptPolicy}
        onChange={(e) => setAcceptPolicy(e.target.checked)}>
        <b style={{ fontWeight: 600 }}>
          {t("modal.policy_need_accept")}{" "}
          <Link href={PATHS.POLICY_PAGE} target={"_blank"}>
            {t("policy")}
          </Link>
        </b>
      </Checkbox>
      {showError && (
        <div>
          <Text className="page-modal-buy-pack-error" strong>
            {t("modal.message_error")}
          </Text>
        </div>
      )}
    </>
  );
};

export default TermAccept;
